import { useContext } from 'react';

import { ChannelServiceRequestFeaturesContext } from '../contexts';

export function useChannelServiceRequestFeaturesContext() {
  return useContext(ChannelServiceRequestFeaturesContext);
}
